import {
  FreeTrialInfo,
  ResellerUserInfo,
  SIGNUP_UPDATE_TYPE,
  SignupUserInfo,
  ValueType,
} from "api/interfaces/authInterface.interface";
import { useEffect, useState } from "react";
import { ValidateMsg } from "api/interfaces/commonInterface.interface";
import OrgNameBubble from "components/blocks/bubble/OrgNameBubble";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import Input from "components/atoms/input/Input";
import { orgNameAlphabetRule, orgNameRule } from "utils/regEx";
import styled from "styled-components";
import { vowel } from "./InputItem";
import { PasswordBubble } from "../SignupStyled";

interface Props {
  validateInputMsg: ValidateMsg;
  onChangeUserInfo: (type: SIGNUP_UPDATE_TYPE, data: string | boolean) => void;
  userInfo: SignupUserInfo | ResellerUserInfo | FreeTrialInfo;
  label: string;
  tabIndex: number;
  fieldKey: string;
  type: SIGNUP_UPDATE_TYPE;
}
function OrgName(props: Props) {
  const {
    validateInputMsg,
    onChangeUserInfo,
    userInfo,
    label,
    tabIndex,
    fieldKey,
    type,
  } = props;
  const [isOrgNameFocus, setIsOrgNameFocus] = useState<boolean>(false);
  const firstLetter = ((label || "").charAt(0) || "").toLowerCase();
  useEffect(() => {
    const value = userInfo[fieldKey as ValueType] as string;
    if (
      !(value.length < 3 || value.length > 100) &&
      !orgNameRule(value) &&
      !orgNameAlphabetRule(value)
    ) {
      let timer = setTimeout(() => {
        setIsOrgNameFocus(false);
      }, 800);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [userInfo[fieldKey as ValueType]]);

  return (
    <ModalInput
      label={label}
      noBold
      essential
      isValidated={!!validateInputMsg[fieldKey]}
      validatedWord={validateInputMsg[fieldKey]}
    >
      <OrgNameInputWrapper>
        <Input
          type="text"
          className="input-field"
          placeholder={`Please enter ${
            vowel.includes(firstLetter) ? "an" : "a"
          } ${label.toLowerCase()}`}
          value={userInfo[fieldKey as ValueType] as string}
          onChange={(e) => onChangeUserInfo(type, e.target.value)}
          onFocus={() => setIsOrgNameFocus(true)}
          onBlur={() => setIsOrgNameFocus(false)}
          isValidated={!!validateInputMsg[fieldKey]}
          autoComplete="new-password"
          tabIndex={tabIndex}
          id="dw_signup_input_org_name"
          data-testid="auth-signup-common-org-name-change-user-info"
        />

        {isOrgNameFocus && (
          <PasswordBubble>
            <OrgNameBubble
              password={userInfo[fieldKey as ValueType] as string}
            />
          </PasswordBubble>
        )}
      </OrgNameInputWrapper>
    </ModalInput>
  );
}

export default OrgName;

const OrgNameInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;
